export const ENTRANCE_ATTENDANCES = "entrance";
export const MIDDLE_ATTENDANCES = "middle";
export const LEAVING_ATTENDANCES = "leaving";
export const ATTENDANCES_LIST = [
    ENTRANCE_ATTENDANCES,
    LEAVING_ATTENDANCES,
    MIDDLE_ATTENDANCES
];
